<template>
  <button
    type="button"
    class="flex h-12 min-w-0 flex-col items-center justify-center px-1 text-center"
    @click="emit('click')"
  >
    <template v-if="primary">
      <span
        class="text-text-neutral-primary block w-full truncate text-base font-semibold"
      >
        {{ primary }}
      </span>
      <span
        class="text-text-neutral-quaternary mt-0.5 block w-full truncate text-xs font-medium"
      >
        {{ secondary || '\u00A0' }}
      </span>
    </template>
    <span
      v-else
      class="block w-full truncate text-base font-semibold"
      :class="placeholderClass"
    >
      {{ placeholder }}
    </span>
  </button>
</template>

<script setup lang="ts">
  import { computed } from 'vue';

  const props = defineProps<{
    primary: string;
    secondary: string;
    placeholder: string;
    hasError?: boolean;
    dataQaId?: string;
  }>();

  const emit = defineEmits<{
    click: [];
  }>();

  const placeholderClass = computed(() =>
    props.hasError
      ? 'text-text-negative-primary'
      : 'text-text-neutral-quaternary',
  );
</script>
